module.exports = __webpack_public_path__ + "static/media/tela-passo-08.479b33ac.jpg";